<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Item Name</label>
                    <model-list-select
                        :list="itemListFromApi"
                        v-model="form.purchaseitem"
                        option-value="itemid"
                        option-text="itemname"
                        placeholder="Select item"
                        isDisabled = "true"
                      >                      
                      </model-list-select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
              <div class="form-group">
                <label>Invoice Date</label>
                <div>
                  <b-form-input
                    type="date"
                    v-model="form.invoicedate"
                    placeholder="Select invoice date"
                  ></b-form-input>
                </div>
              </div>
            </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Supplier Name</label>
                   <div>
                    <model-list-select
                        :list="vendorListFromApi"
                        v-model="form.vendor"
                        option-value="vendorid"
                        option-text="vendorname"
                        placeholder="Select Supplier"
                      >
                      </model-list-select>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Quantity</label>
                  <b-form-input type="number"  v-model="form.quantity" @input="calculateTotalOnChange"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Price</label>
                  <b-form-input type="number" v-model="form.unitprice" @input="calculateTotalOnChange" />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Total Price</label>
                  <b-form-input type="number"  v-model="form.totalprice" :disabled="true"/>
                </div>
              </div>
            </div>
            <div class="row">
               <div class="col-lg-12">
               <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="purchaselist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { ModelListSelect } from "vue-search-select"
import { mapGetters } from 'vuex';
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        purchaseitem: '',
        purchasedate: '',
        vendor: '',
        quantity: '0',
        unitprice: '0',
        totalprice: '0',
        invoicedate: '',
        locationid:'',
      },
      filter: true,
      id: this.$route.query.id,
      title: "Edit Purchase Item",
      title1: "Edit purchase",
      itemListFromApi: [],
      vendorListFromApi: [],
      
    };
  },
  created(){
    this.fetchItemListFromApi();
    this.fetchVendorListFromApi();
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
 methods: {
    calculateTotalOnChange() {
      const unitPrice = parseFloat(this.form.unitprice);
      const quantity = parseFloat(this.form.quantity);
      this.form.totalprice = (isNaN(unitPrice) || isNaN(quantity)) ? '0' : (unitPrice * quantity).toFixed(2);
    },
    async fetchItemListFromApi() {
    try {
      const response = await axios.get(`/v1/items?locationid=${this.locationId}`);
      this.itemListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching item list:', error);
      }
    },
    
    async fetchVendorListFromApi() {
    try {
      const response = await axios.get(`/v1/vendors?locationid=${this.locationId}`);
      this.vendorListFromApi = response.data; 
    } catch (error) {
      console.error('Error fetching item list:', error);
      }
    },
  
    postData() {
      if (!this.form.purchaseitem) {
        Swal.fire("Pleas enter the purchase item name");
        return;
      }
      console.log("Selected Invoice Date:", this.form.invoicedate);
      this.form.invoicedate = moment(this.form.invoicedate).format("YYYY-MM-DDTHH:mm:ss");
      axios
      .put('/v1/purchases/' + this.id, this.form)
      .then(response => {
        Swal.fire("Purchase updated successfully");
        this.$router.push({ path: '/purchaselist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getPurchaseById(id) {
  try {
    const response = await axios.get('/v1/purchases/' + id);
    this.form = response.data;

    if (this.form.invoicedate) {
      const date = new Date(this.form.invoicedate);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      this.form.invoicedate = `${year}-${month}-${day}`;
    }
  } catch (error) {
    console.log(error);
    this.errored = true;
  }
}
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getPurchaseById(this.id);
  },
  components: {
    ModelListSelect
  },
  name: "editpurchase",
};
</script>
